module.exports = __webpack_public_path__ + "img/background.96a622fb.jpg";